export default __webpack_public_path__ + "static/media/toinhabrasilshow-pub.bd83fc79.png";